import React, { useState, useRef, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import './App.css';
import { doc, updateDoc } from 'firebase/compat/firestore'

firebase.initializeApp({
  apiKey: "AIzaSyAzTPfOUdgUyGzFFELhN1bRU0G5et7X0uo",
  authDomain: "swiftchat-a0393.firebaseapp.com",
  projectId: "swiftchat-a0393",
  storageBucket: "swiftchat-a0393.appspot.com",
  messagingSenderId: "515447249922",
  appId: "1:515447249922:web:6d04fd504a2d10643bdb1b",
  measurementId: "G-Q37EJLLWNC"
});

const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {
  const [user] = useAuthState(auth);

  return (
    <div className="flex h-screen">
      {user && <Sidebar />}
      <section className="flex-grow">
        <header className="py-2 px-4 bg-gray-800 text-white flex justify-between items-center">
          <h1>Talkalio</h1>
          {user && (
            <button
              onClick={() => auth.signOut()}
              className="text-white bg-red-500 px-2 py-1 rounded ml-4 hover:bg-red-600"
            >
              Sign Out
            </button>
          )}
        </header>
        <main className="">
          {user ? <HomePage /> : <SignIn />}
        </main>
      </section>
    </div>
  );
  
}

function Sidebar() {
  const currentUser = auth.currentUser;
  const channels = ['#general', '#chat', '#fun'];
  const emojis = ['🌐', '💬', '🥳'];

  return (
    
    <aside className="bg-gray-800 sm:w-1/6 md:w-1/5 p-2">
    <div className="flex flex-col text-center justify-between h-full">
      <div>
        <img
          className="mt-2 rounded w-full mx-auto"
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfzMuEN9l9CkQPMWGjwnk1L8E7qz3ia_ICerwLX2MViw&s"
          alt=""
        />
        <div className="mt-4">
          <h1 className="text-white mb-5 font-bold text-xl">Aww Crap</h1>
          <div>
            {channels.map((value, index) => (
              <button
                key={index}
                className="text-white mb-2 text-left bg-gray-600 text-lg px-0 py-2 md:px-4 lg:px-4 md:py-2 lg:py-2 rounded-lg mb-1 block w-full hover:bg-gray-500"
              >
                <span>{emojis[index]} {value}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
  
      {currentUser && (
        <div className="mb-5 p-2">
          <div className="flex items-center">
            <img
              src={currentUser.photoURL || 'https://example.com/default-avatar.png'}
              alt="User Avatar"
              className="w-10 h-10 rounded-full mr-2"
            />
            <div>
              <p className="text-white">{currentUser.displayName}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  </aside>
  
  );
}

function HomePage() {
  const messagesRef = firestore.collection('posts');
  const query = messagesRef.orderBy('createdAt').limit(25);

  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');

  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL, displayName } = auth.currentUser;

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL,
      displayName,
    });

    setFormValue('');
  };
 
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(scrollToBottom, [messages]);

  return (
    <div className="h-full flex flex-col">
    <div className="overflow-y-auto flex-grow">
      {messages &&
        messages.map((message) => (
          <PostContent
            key={message.id}
            message={message}
            currentUser={auth.currentUser}
            displayName={message.displayName}
          />
        ))}
      <div ref={messagesEndRef} />
    </div>
      <form className="p-4 flex" onSubmit={sendMessage}>
        <input
          className="rounded-l-lg border-2 border-indigo-500/50 p-2 w-full"
          value={formValue}
          onChange={(e) => setFormValue(e.target.value)}
          placeholder="Type a message..."
        />
        <button className="bg-blue-500 text-white rounded-r-lg px-7 py-1">Send</button>
      </form>
    </div>
  );
}

function PostContent(props) {
  const { text, photoURL, displayName, createdAt } = props.message;
  const currentUser = auth.currentUser;
  const [timeAgo, setTimeAgo] = useState('');
  const [showTimestamp, setShowTimestamp] = useState(false);

  useEffect(() => {
    // Calculate the time difference between the current time and the message's timestamp
    const calculateTimeAgo = () => {
      if (createdAt) {
        const currentTime = new Date();
        const messageTime = createdAt.toDate();
        const timeDifference = Math.abs(currentTime - messageTime);
        let timeAgo = '';

        // Calculate the appropriate unit (seconds, minutes, hours, days)
        if (timeDifference < 60000) {
          timeAgo = Math.floor(timeDifference / 1000) + ' seconds ago';
        } else if (timeDifference < 3600000) {
          timeAgo = Math.floor(timeDifference / 60000) + ' minutes ago';
        } else if (timeDifference < 86400000) {
          timeAgo = Math.floor(timeDifference / 3600000) + ' hours ago';
        } else {
          timeAgo = Math.floor(timeDifference / 86400000) + ' days ago';
        }

        setTimeAgo(timeAgo);
      }
    };

    calculateTimeAgo();

    // Refresh the timestamp every 1 minute
    const interval = setInterval(() => {
      calculateTimeAgo();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [createdAt]);

  return (
    <div
      className="message received flex mb-2"
      onMouseEnter={() => setShowTimestamp(true)}
      onMouseLeave={() => setShowTimestamp(false)}
    >
      <div className="flex items-start justify-start">
        <div className="message-content p-2 rounded-lg">
          <div className="username-container">
            <div className="line-divider" />
            <div className="flex items-center mb-1">
              <img
                src={photoURL || 'https://example.com/default-avatar.png'}
                alt="User Avatar"
                className="w-6 h-6 rounded-full mr-2 mb-3"
              />
              <div>
                <p className="font-semibold">
                  {displayName}{' '}
                  {showTimestamp && (
                    <span className="gray-100 font-light">{currentUser && currentUser.uid === props.message.uid && `(${timeAgo})`}</span>
                  )}
                </p>
                <p className="text-sm">{text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  };

  return (
    <div className="flex flex-col items-center mt-40">
      <h1 className="text-4xl mb-8">Swift Chat</h1>
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        onClick={signInWithGoogle}
      >
        Sign in with Google
      </button>
    </div>
  );
}

export default App;
